module.exports = __webpack_public_path__ + "static/hero-74cb6845387770afdf0fd577ba3ae505.jpg";